import React, { Component } from 'react';
import { connect } from 'react-redux';

// Actions
import { signin, cleanSigninError, forgotPassword, cleanForgotPasswordError } from '../actions/auth';

// Images
import bgImage from '../assets/img/bg-login.jpg';
import logo from '../assets/img/logo-cn-processed-steel-200x161.jpg';
import infoLogo from '../assets/img/info-logo.png';
import federLogo from '../assets/img/feder-logo.jpg';


// Components
import SigninForm from '../components/auth/SigninForm';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';

const styles = {
    pageWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: `url(${bgImage}) center no-repeat fixed`,
        backgroundSize: window.innerWidth + 'px',
        height: window.innerHeight + 'px'
    },
    loginContainer: {
        background: 'rgba(255,255,255)',
        maxWidth: '400px',
        width: '90%'
    },
    logoWrapper: {
        height: 161,
        width: '100%',
        padding: '10px',
        margin: '30px 0 5px',
        background: `url(${logo}) center top no-repeat`
    },
    bodyWrapper: {
        padding: '10px',
        width: '100%'
    },
    footerWrapper: {
        padding: '15px',
        backgroundColor: 'rgb(134, 149, 163)',
        color: '#fff',
        width: '100%',
        fontSize: 13
    }
};

class Signin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            screen: 'signin'
        };

        this.toggleScreen = this.toggleScreen.bind(this);

        this.handleSignin = this.handleSignin.bind(this);
        this.handleCleanSigninError = this.handleCleanSigninError.bind(this);

        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.handleCleanForgotPasswordError = this.handleCleanForgotPasswordError.bind(this);
        this.handleForgotPasswordSuccess = this.handleForgotPasswordSuccess.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isLoggedIn) {
            this.props.history.push('/');
        }
    }

    toggleScreen(screen) {
        if (screen) {
            this.setState({
                screen: screen
            });
        }
    }

    handleSignin(credentials) {
        this.props.signin({
            username:  credentials.email,
            password: credentials.password
        });
    }

    handleCleanSigninError() {
        this.props.cleanSigninError();
    }

    handleForgotPassword(email){
        if(email){
            this.props.forgotPassword(email);
        }
    }

    handleForgotPasswordSuccess(){
        this.setState({
                screen: 'signin'
            });
    }

    handleCleanForgotPasswordError() {
        this.props.cleanForgotPasswordError();
    }

    render() {
        let formBody;

        switch (this.state.screen) {
            case 'signin':
                formBody = (
                    <SigninForm
                        toggleScreen={this.toggleScreen}
                        signin={this.handleSignin}
                        error={this.props.signinErrorMessage}
                        cleanSigninError={this.handleCleanSigninError}
                    />
                );
                break;
            case 'forgot-password':
                formBody = (
                    <ForgotPasswordForm
                        screen={this.state.screen}
                        toggleScreen={this.toggleScreen}
                        forgotPassword={this.handleForgotPassword}
                        forgotPasswordSuccess={this.handleForgotPasswordSuccess}
                        cleanError={this.handleCleanForgotPasswordError}
                        isFetching={this.props.forgotPasswordIsFetching}
                        success={this.props.forgotPasswordSuccess}
                        error={this.props.forgotPasswordError}
                        errorMessage={this.props.forgotPasswordErrorMessage}
                    />
                );
                break;
            default:
                formBody = null;
                break;
        }

        return (
            <div style={styles.pageWrapper} >
                <div className="row" style={styles.loginContainer}>
                    <div style={styles.logoWrapper} />
                    <div style={styles.bodyWrapper}>
                        {formBody}
                    </div>
                    {this.state.screen === 'signin' ? (
                        <div style={styles.footerWrapper}>
                            <a onClick={() => this.toggleScreen('forgot-password')}>¿Has olvidado tu contraseña?</a>
                        </div>
                    ) : null}
                    <div style={{ width: '100%', padding: 10, backgroundColor: '#fff' }}>
                        <div>
                            Proyecto cofinanciado por:
                        </div>
                        <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <img src={federLogo} alt="FEDER Logo" width={150}/>
                            <img src={infoLogo} alt="INFO Logo" width={100}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    // Reducers
    const sessionReducer = state.auth.session;
    const forgotPasswordReducer = state.auth.forgotPassword;

    // Session
    const isLoggedIn = sessionReducer.isLoggedIn,
        errorCode = sessionReducer.get('errorSignin');

    // Forgot Password
    const forgotPasswordIsFetching = forgotPasswordReducer.get('isFetching'),
        forgotPasswordError = forgotPasswordReducer.get('error'),
        forgotPasswordErrorCode = forgotPasswordReducer.get('errorCode'),
        forgotPasswordSuccess = forgotPasswordReducer.get('success');

    let forgotPasswordErrorMessage = forgotPasswordError ? ('' + forgotPasswordErrorCode) : '';

    return {
        isLoggedIn,
        signinErrorMessage: errorCode || '',
        forgotPasswordIsFetching, forgotPasswordSuccess, forgotPasswordErrorMessage, forgotPasswordError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        signin: ({ username, password }) => dispatch(signin({ username, password })),
        cleanSigninError: () => dispatch(cleanSigninError()),
        forgotPassword: (email) => dispatch(forgotPassword(email)),
        cleanForgotPasswordError: () => dispatch(cleanForgotPasswordError())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin);



// WEBPACK FOOTER //
// ./src/containers/Signin.js